module.exports = __webpack_public_path__ + "img/ergLogo5@2x.6a0350b1.jpg";